import React, { useEffect, useRef, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'
import { Check, XIcon } from '@phosphor-icons/react'
import { FLAG_DEFS, FlagKey } from './memberFlags.constants'

interface Props {
  selected: FlagKey[]
  onChange: (next: FlagKey[]) => void
}

export const FlagsFilterDropdown = ({ selected, onChange }: Props) => {
  const [open, setOpen] = useState(false)
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!open) return
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false)
      }
    }
    document.addEventListener('mousedown', handler)
    return () => document.removeEventListener('mousedown', handler)
  }, [open])

  const toggle = (key: FlagKey) => {
    onChange(
      selected.includes(key)
        ? selected.filter(k => k !== key)
        : [...selected, key],
    )
  }

  return (
    <div className="tm-filter" ref={ref}>
      <span className="tm-filter__label">Flags</span>
      <div className="tm-filter__select-wrap">
        <button
          type="button"
          className="tm-filter__select tm-filter__flags-trigger"
          onClick={() => setOpen(o => !o)}
        >
          {selected.length > 0 ? `Flags (${selected.length})` : 'All Flags'}
        </button>
        <FontAwesomeIcon
          className="tm-filter__chevron"
          icon={faChevronDown}
        />
        {open && (
          <div className="tm-filter__flags-dropdown">
            {FLAG_DEFS.map(def => {
              const checked = selected.includes(def.key)
              return (
                <label
                  key={def.key}
                  className="tm-filter__flags-option"
                  onClick={() => toggle(def.key)}
                >
                  <span
                    className={`tm-filter__flags-checkbox${
                      checked ? ' tm-filter__flags-checkbox--checked' : ''
                    }`}
                  >
                    {checked && <Check size={10} weight="bold" color="#fff" />}
                  </span>
                  <def.Icon size={13} weight={def.weight} color={def.color} />
                  <span>{def.label}</span>
                </label>
              )
            })}
            {selected.length > 0 && (
              <>
                <div className="tm-filter__flags-divider" />
                <button
                  type="button"
                  className="tm-filter__flags-option tm-filter__flags-clear"
                  onClick={() => onChange([])}
                >
                  <XIcon size={13} weight="regular" color="#717182" />
                  Clear all
                </button>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  )
}
